import { lazy } from "react";
import RouteGuard from "../routerPermission";

const AnalyticsPage = lazy(() => import("@/widgets/analytics/AnalyticsPage"));

const AnalyticsRoutes = {
  path: "analytics",
  children: [
    {
      path: "",
      // Same rule as the sidebar row and the backend (order.read on every
      // analytics route), so a typed URL meets the same gate as the menu.
      element: (
        <RouteGuard resource="order" action="read">
          <AnalyticsPage />
        </RouteGuard>
      ),
    },
  ],
};

export default AnalyticsRoutes;
